import { render, staticRenderFns } from "@/manager/sync/views/syncDetail/syncDetail.pug?vue&type=template&id=1960e100&scoped=true&lang=pug&external"
import script from "./syncDetail.view.vue?vue&type=script&lang=ts"
export * from "./syncDetail.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/sync/views/syncDetail/syncDetail.scss?vue&type=style&index=0&id=1960e100&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960e100",
  null
  
)

export default component.exports